import {defineMessages} from 'react-intl';

const messages = defineMessages({
  noResponse: {
    id: 'noResponse',
    defaultMessage: 'No Response'
  }
});

export default messages;
